export default "__VITE_ASSET__CAFjrW8c__"